import React, {useEffect, useState} from 'react';
import dynamic from 'next/dynamic';
import Sticky from 'react-sticky-el';
import { Grid, Row } from 'react-styled-flexboxgrid';
import TextButton from '../../components/TextButton';
import { IoMdFunnel } from 'react-icons/io';
import useMediaQuery from '../../helpers/mediaQuery';
import FilterList from './FilterList';
import { Holder, Col, SideDrawerInner, FilterListTop } from './style';
import SideDrawer from 'reusecore/src/elements/Drawer';
import Icon from 'react-icons-kit';
import { androidClose } from 'react-icons-kit/ionicons/androidClose';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
// dynamic imports
const Highlights = dynamic(() =>
  import('../../components/ListView/Featured/List/Top/index')
);
const SearchPost = dynamic(() => import('./SearchPost/index'));
const SkazyAdvertising = dynamic(
  () => import('../../components/SkazyAdvertising'),
  { ssr: false }
);

const SearchPage = props => {
  const router = useRouter();
  const { t } = useTranslation();

  const [filterDrawerState, toggleFilterDrawer] = useState(false);

  const isDesktop = useMediaQuery('(max-width: 1188px)');

  let { category, text } = router.query;

  if (category === 'all') {
    category = null;
  }

  const handleFilterToggle = () => toggleFilterDrawer(!filterDrawerState);

  const topAds = category === 'voitures' ? {n: process.env.SKAZY_AD_ENCART_TOP_N_VOITURES, id: process.env.SKAZY_AD_ENCART_TOP_ID_VOITURES} : {n: process.env.SKAZY_AD_ENCART_TOP_N, id: process.env.SKAZY_AD_ENCART_TOP_ID};
  const bottomAds = category === 'voitures' ? {n: process.env.SKAZY_AD_ENCART_BOTTOM_N_VOITURES, id: process.env.SKAZY_AD_ENCART_BOTTOM_ID_VOITURES} : {n: process.env.SKAZY_AD_ENCART_BOTTOM_N, id: process.env.SKAZY_AD_ENCART_BOTTOM_ID};

  return (
    <div>
      <Grid style={{ paddingLeft: '1rem', paddingRight: '1rem' }}>
        {process.env.SEARCH_PRO === '1' && (
          <Highlights category={category} text={text} />
        )}
        <Row>
          <SkazyAdvertising
            name="ext2"
            zone={{ n: process.env.SKAZY_AD_EXT_N, id: process.env.SKAZY_AD_EXT_ID }}
            height={945}
            width={200}
            containerStyle={{
              display: isDesktop ? 'none' : 'block',
              position: 'absolute',
              transform: 'translateX(-230px)',
            }}
          />
          <SkazyAdvertising
            name="ext2"
            zone={{ n: process.env.SKAZY_AD_EXT_N, id: process.env.SKAZY_AD_EXT_ID }}
            height={945}
            width={200}
            containerStyle={{
              display: isDesktop ? 'none' : 'block',
              position: 'absolute',
              transform: 'translateX(77rem)',
            }}
          />
          <Col className="colFilter" xs={0} sm={5} md={4}>
            <FilterListTop>
              <FilterList />
              <Sticky
                boundaryElement=".colFilter"
                disabled
                topOffset={-75}
                stickyStyle={{ top: 75 }}
              >
                <div
                  style={{
                    display: 'flex',
                    height: 900,
                    flex: 1,
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    paddingTop: 20,
                  }}
                >
                  <SkazyAdvertising
                    name="encart1"
                    zone={topAds}
                    height={600}
                    width={300}
                  />
                  <SkazyAdvertising
                    name="encart2"
                    zone={bottomAds}
                    height={250}
                    width={300}
                  />
                </div>
              </Sticky>
            </FilterListTop>
          </Col>

          <Col id="colPosts" xs={12} sm={12} md={8}>
            <Holder>
              <TextButton
                title={t('search.sidebar.title')}
                iconPosition="left"
                icon={<IoMdFunnel />}
                onClick={handleFilterToggle}
                style={{ margin: 'auto', padding: '25px 0px 10px 0px' }}
                className="md-hidden"
              />
            </Holder>

            {/* Search filter Drawer which only show on mobile and tab */}
            {filterDrawerState && (
              <SideDrawer
                width="80vw"
                open={filterDrawerState}
                onClose={handleFilterToggle}
                toggleHandler={handleFilterToggle}
                closeButton={
                  <Icon icon={androidClose} size={21} color="#333333" />
                }
                closeButtonStyle={{
                  display: 'inline-flex',
                  position: 'absolute',
                  top: 20,
                  right: 20,
                  cursor: 'pointer',
                }}
              >
                <SideDrawerInner>
                  <FilterList toggleSearchDrawer={handleFilterToggle} />
                </SideDrawerInner>
              </SideDrawer>
            )}
            <SearchPost
              {...props}
              categorySlug={category}
              category={category ? t('category.slug.' + category) : null}
            />
          </Col>
        </Row>
      </Grid>
    </div>
  );
};

export default SearchPage;
